// extracted by mini-css-extract-plugin
export var active = "_cd-7";
export var container = "_cd-0";
export var evenWidth = "_cd-4";
export var large = "_cd-5";
export var outlet = "_cd-8";
export var slide = "_cd-2";
export var small = "_cd-6";
export var tab = "_cd-3";
export var tabs = "_cd-1";